import {
  ENGINEER_FILTER,
  STOCK_RETURN_GMDS_CODE_FILTER,
  STOCK_RETURN_ITEM_DESCRIPTION_FILTER,
  STOCK_RETURN_ITEM_LOCATION_FILTER,
  STATUS_FILTER,
} from "../../custom/Utils/ListFilterOptions";

export const basicFormData = () => ({
  inputData: {
    technician_id: "",
    material_id: "",
    available_qty: "",
    return_qty: "",
    item_location: "",
    is_active: true,
  },
});

export const createPageData = () => {
  const schema = localStorage.getItem("schema");
  const payload = {
    modelName: "technician_stock_returns",
    schema: schema,
    include: [
      {
        model: "user_masters",
        as: "technician",
      },
      {
        model: "material_masters",
        as: "material",
      },
    ],
  };

  const navigatePage = { back: "/technician-stock-return-list" };

  const headerName = "Engineer Stock Return";

  const validationType = "TechnicianStockReturnCreate";
  const endpoint = "/updaterelationaldata  ";
  const getEndpoint = "/getRecords";

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    endpoint,
    getEndpoint,
  };
};

export const listPageData = () => {
  const schema = localStorage.getItem("schema");
  const payload = {
    modelName: "technician_stock_returns",
    schema: schema,
    include: [
      {
        model: "user_masters",
        as: "technician",
      },
      {
        model: "material_masters",
        as: "material",
      },
    ],
  };

  const navigatePage = {
    create: "/technician-stock-return-create",
    edit: "/technician-stock-return-create",
    view: "/technician-stock-return-view",
  };

  const searchfields = [
    "technician.first_name",
    "technician.last_name",
    "material.gmds_code",
    // "quantity",
  ];

  const filterConfig = [
    ENGINEER_FILTER,
    STOCK_RETURN_GMDS_CODE_FILTER,
    STOCK_RETURN_ITEM_DESCRIPTION_FILTER,
    STOCK_RETURN_ITEM_LOCATION_FILTER,
    STATUS_FILTER,
  ];

  const headerName = "Engineer Stock Return";
  const endpoint = "/getRecords";
  const exportFileName = "EngineerStockReturnData.xlsx";

  return {
    payload,
    navigatePage,
    headerName,
    endpoint,
    searchfields,
    exportFileName,
    filterConfig,
  };
};
